// 客服1菜单
const menus = [
  {
    icon: 'el-icon-lx-home',
    index: '/simpleIndex',
    title: '系统首页',
  },
  {
    icon: 'el-icon-goods',
    index: '2',
    title: '商品管理',
    subs: [
      {
        index: '/goodsList',
        title: '商品列表',
      },
      {
        index: '/indexGoodsList',
        title: '首页商品管理',
      },
      {
        index: '/paymentDiscountGoodsList',
        title: '支付立减商品管理',
      },
      {
        index: '/goodsAuditList',
        title: '商品审核',
      },
      {
        index: '/classify',
        title: '分类列表',
      },
    ],
  },
  {
    icon: 'el-icon-lx-copy',
    index: '7',
    title: '运营管理',
    subs: [
      {
        index: '/activityList',
        title: '活动管理',
      },
    ],
  },

]

export default menus
